import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import _ from 'lodash';

const FilterTags = props => (
  <div className="dashboard-filters-results">
    {_.map(props.tags, tag => (
      <div key={tag.key} className="filter-tag btn-with-icon mr-2">
        {`${tag.label}: "${tag.value}"`}
        <Button className="icon-close filter__icon" onClick={tag.onClearFilter} />
      </div>
    ))}
    {_.size(props.tags) > 0 && props.onClearFilters && (
      <Button className="filter-tag" color="link" onClick={() => props.onClearFilters()}>
        Clear All Filters
      </Button>
    )}
  </div>
);

FilterTags.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.string,
      onClearFilter: PropTypes.func,
    }),
  ),
  onClearFilters: PropTypes.func,
};

export default FilterTags;
